import React, { useState, useEffect, useCallback  } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import axios from 'axios';
import { Authenticator } from '@aws-amplify/ui-react';
import { Helmet } from 'react-helmet';
import { useTitle } from '../TitleContext';

const AuthenticatedApp = ({ user }) => {
  const { storeName } = useParams();
  const [tempKey, setTempKey] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const [error, setError] = useState(null);

  // APIリクエスト関数
  const fetchUserData = useCallback(async ()  => {
    try {
      console.log('Authenticated User:', user);
      console.log('StoreName:',storeName);

      // ユーザーIDを取得
      const userId = user.userId || user.attributes?.sub || user.sub;

      if (!userId) {
        throw new Error('ユーザーIDが取得できませんでした。');
      }

      setUserInfo({ UserId: userId });

      console.log('addAPI:', userId);

      // リクエストデータを作成
      const requestData = {
        username: user.username,
        store: storeName,
      };

      console.log('Request Data:', requestData);

      // APIリクエストを送信（Authorizationヘッダーは不要であれば削除）
      const response = await axios.post(
        'https://2oimvioc09.execute-api.ap-northeast-1.amazonaws.com/prod/setup',
        requestData,
        {
          timeout: 10000,
        }
      );

      // レスポンスデータのログ
      console.log('Response Data:', response.data);

      // レスポンスボディをパース
      const responseData = response.data.body
        ? JSON.parse(response.data.body)
        : response.data;
      console.log('Parsed Response Body:', responseData);

      setTempKey(responseData.temp_key);
    } catch (error) {
      console.error('APIリクエストエラー:', error);
      setError('QRコード生成に失敗しました。再度お試しください。');
    }
  }, [user, storeName]);

  // useEffect を使用して fetchUserData を呼び出す
  useEffect(() => {
    if (!tempKey && !error) {
      fetchUserData();
    }
  }, [tempKey, error, fetchUserData]);

  // エラー表示
  if (error) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1>{error}</h1>
      </div>
    );
  }

  // tempKey または userInfo がまだ取得されていない場合はローディング画面を表示
  if (!tempKey || !userInfo) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1>QRコード生成中...</h1>
      </div>
    );
  }

  const qrValue = `userId=${userInfo.UserId}&tempKey=${tempKey}&storeName=${storeName}\n\n`;

  const simpleEncrypt = (data, key) => {
    let encrypted = '';
    for (let i = 0; i < data.length; i++) {
      encrypted += String.fromCharCode(
        ((data.charCodeAt(i) - 32 + key.charCodeAt(i % key.length) - 32) % 95) + 32
      );
    }
    return encrypted;
  };

  const secretKey = '0123'; // 簡単なキーを使用
  const encryptedData = simpleEncrypt(qrValue, secretKey);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>入店用QRコード</h1>
      <QRCodeCanvas value={encryptedData} size={256} />
      <p>{encryptedData}</p>
    </div>
  );
};

const QrCodePage = () => {
  const { defaultTitle } = useTitle();
  return (
    <div><Helmet>
              <title>{`${defaultTitle} - QRコード`}</title>
            </Helmet>
    <Authenticator>
      {({ signOut, user }) => {
        // ユーザーが認証されていない場合はローディング画面を表示
        if (!user) {
          return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <h1>認証中...</h1>
            </div>
          );
        }

        // 認証されたユーザーを渡して AuthenticatedApp をレンダリング
        return <AuthenticatedApp user={user} />;
      }}
    </Authenticator></div>
  );
};

export default QrCodePage;
